export default function getRgbaAlpha(rgba) {
  const values = rgba.substr(5).split(')')[0].split(',');

  return values[3];
}
